import { GENERATOR_NAMES } from 'common/components/CopyMagic/constants';
import type { EventDetailType } from './CopyMagicEvents.types';
import { EVENT_NAMES } from './constants';

/*
CopyMagicEvents
  A lightweight wrapper around the browser's addEventListener API
  to enforce a specific event name and generator name.

Example:
  CopyMagicEvents.addListener(
    CopyMagicEvents.EVENT_NAMES.CALLBACK_OPEN,
    CopyMagicEvents.GENERATOR_NAMES.CONVERSATION_ASSISTANT,
  );
  CopyMagicEvents.dispatch(
    CopyMagicEvents.EVENT_NAMES.COMMAND_OPEN,
    CopyMagicEvents.GENERATOR_NAMES.CONVERSATION_ASSISTANT,
  );
*/

type EventNameType = (typeof EVENT_NAMES)[keyof typeof EVENT_NAMES];
type GeneratorNameType = (typeof GENERATOR_NAMES)[keyof typeof GENERATOR_NAMES];
// eslint-disable-next-line no-unused-vars
type ListenerType = (event: CustomEvent<EventDetailType>) => void;

class CopyMagicEvents {
  static EVENT_NAMES = EVENT_NAMES;

  static GENERATOR_NAMES = GENERATOR_NAMES;

  static dispatch(eventName: EventNameType, generatorName: GeneratorNameType) {
    window.dispatchEvent(
      new CustomEvent<EventDetailType>(eventName, { detail: { generatorName } }),
    );
  }

  static addListener(eventName: EventNameType, listener: ListenerType) {
    window.addEventListener(eventName, listener as EventListener);
  }

  static removeListener(eventName: EventNameType, listener: ListenerType) {
    window.removeEventListener(eventName, listener as EventListener);
  }
}

export default CopyMagicEvents;
